import {
  RECEIVED_AUTH_USER,
  CLEAR_AUTH_USER
} from '../modules/auth/actions'
import {
  RECEIVED_COOKIE_USER
} from '../modules/session/actions'
import { firestore } from '../utils/firebase'
import { receivedViewingRequests } from '../modules/schedule/actions'

export default store => next => action => {
  switch (action.type) {
    case RECEIVED_AUTH_USER:
      next(action)

      if (action.authUser) {
        startSyncingViewingRequests(store, action.authUser.id)
      }

      break

    case RECEIVED_COOKIE_USER:
      next(action)

      if (action.cookieUser) {
        startSyncingViewingRequests(store, action.cookieUser.id)
      }

      break

    case CLEAR_AUTH_USER:
      next(action)
      stopSyncingViewingRequests()
      break

    default:
      next(action)
  }
}

let unsubscribe

export function startSyncingViewingRequests (store, userId) {
  stopSyncingViewingRequests()

  unsubscribe = firestore
    .collection('viewing_requests')
    .where('userId', '==', userId)
    .onSnapshot(async viewingRequestQuery => {
      const viewingRequests = new Map()

      viewingRequestQuery.docs.forEach(doc => {
        const viewingRequest = doc.data()

        viewingRequests.set(viewingRequest.propertyId, viewingRequest)
      })

      store.dispatch(receivedViewingRequests(viewingRequests))
    })
}

export function stopSyncingViewingRequests () {
  unsubscribe && unsubscribe()
}
